import { render, staticRenderFns } from "./ReviewUs.vue?vue&type=template&id=2777a3d4&scoped=true"
import script from "./ReviewUs.vue?vue&type=script&lang=js"
export * from "./ReviewUs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2777a3d4",
  null
  
)

export default component.exports